<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs v-model="activeKey">
        <a-tab-pane key="1" tab="薪资预支条件薪资预支规则">
          <a-form-model ref="form" :model="resultDate" :rules="rules">
            <a-form-model-item label="富文本" prop="content">
              <editor :editorValue="'editor'" v-model="resultDate.content" placeholder="请输入" />
            </a-form-model-item>
          </a-form-model>
          <a-button type="primary" :loading="loading" @click="submitForm(1)">
            保存
          </a-button>
        </a-tab-pane>
        <a-tab-pane key="2" tab="用户协议">
          <a-form-model ref="form" :model="resultDate1" :rules="rules">
            <a-form-model-item label="富文本" prop="content">
              <editor :editorValue="'editor1'" v-model="resultDate1.configValue" placeholder="请输入" />
            </a-form-model-item>
          </a-form-model>
          <a-button type="primary" :loading="loading" @click="submitForm(2)">
            保存
          </a-button>
        </a-tab-pane>
        <a-tab-pane key="3" tab="隐私政策">
          <a-form-model ref="form" :model="resultDate2" :rules="rules">
            <a-form-model-item label="富文本" prop="content">
              <editor :editorValue="'editor2'" v-model="resultDate2.configValue" placeholder="请输入" />
            </a-form-model-item>
          </a-form-model>
          <a-button type="primary" :loading="loading" @click="submitForm(3)">
            保存
          </a-button>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRule, updateRule } from '@/api/user/rule'
import Editor from '@/components/Editor/Editor'

const {getConfig, updateConfig} = require("@/api/system/config");
export default {
  name: 'ByFourIndex',
  components: { Editor },
  data() {
    return {
      description: '规则设置',
      activeKey: '1', // 被选中的tab
      list: [],
      loading: false,
      resultDate: {
        id: null,
        content: ""
      },
      resultDate1: {
        id: null,
        configValue: ""
      },
      resultDate2: {
        id: null,
        configValue: ""
      },
      // 查询参数
      queryParam: {
        type: 4
      },
      rules: {}
    }
  },
  created() {
    this.getList()
  },
  computed: {},
  methods: {
    /** 查询规则列表 */
    getList () {
      this.loading = true
      pageRule(this.queryParam).then(response => {
        this.list = response.data.records
        if (this.list.length > 0) {
          this.resultDate = this.list[0]
        }
        this.loading = false
      })
      getConfig({ 'id': '1668157783460876001' }).then(response => {
        this.resultDate1.id = response.data.id
        this.resultDate1.configValue = response.data.configValue
      })
      getConfig({ 'id': '1668157783460876002' }).then(response => {
        this.resultDate2.id = response.data.id
        this.resultDate2.configValue = response.data.configValue
      })
    },
    submitForm(num) {
      if (num == 1) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading = true
            updateRule(this.resultDate).then(res => {
              this.loading = false
              this.$message.success(
                '修改成功',
                3
              )
              this.$emit('ok')
            }).finally(() => {
              this.getList()
            })
          } else {
            return false
          }
        })
      }
      if (num == 2) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading = true
            updateConfig(this.resultDate1).then(res => {
              this.loading = false
              this.$message.success(
                '修改成功',
                3
              )
              this.$emit('ok')
            }).finally(() => {
              this.getList()
            })
          } else {
            return false
          }
        })
      }
      if (num == 3) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading = true
            updateConfig(this.resultDate2).then(res => {
              this.loading = false
              this.$message.success(
                '修改成功',
                3
              )
              this.$emit('ok')
            }).finally(() => {
              this.getList()
            })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
